<template>
  <v-container fluid class="marketplatform-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-space-between justify-md-start overflow-auto">
              <v-btn to="/marketplatform/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              loading-text="Loading... Please wait"
              class="marketplatforms-table"
              sort-by="platformnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="platforms"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Marketing Platform?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_platform.platformnum }} 
                      {{ delete_platform.platformname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_platform)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.platformimage="{ item }">
                    <v-img
                    v-if="item.platformimage" 
                    v-bind:src="item.platformimage"
                    max-height="100"
                    max-width="100"
                  ></v-img>
              </template>
              <template v-slot:item.platformnum="{ item }">
                <p class="two-line">{{ item.platformtype  }}</p>
              </template>
              <template v-slot:item.platformname="{ item }">
                <p class="two-line">{{ item.platformname }}</p>
              </template>
              <template v-slot:item.platformstatus="{ item }">
                <v-chip
                  v-if="item.platformstatus!=undefined"
                  :color="item.platformstatus=='New' ? 'primaryConst white--text' : item.platformstatus=='Completed' ? 'successConst white--text' : item.platformstatus=='Credit' ? 'orangeConst white--text' : item.platformstatus=='Partial' ? 'warning white--text' : 'secondaryConst white--text'" small>
                  {{ item.platformstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.platformstatus!=='Completed'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MarketPlatformList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      findMarketPlatformDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_platform: {},
      query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Image', value: 'platformimage', sortable: false, width: "10%" },
        { text: 'Type', value: 'platformnum', sortable: false },
        { text: 'Name', value: 'platformname' },
        { text: 'Status', value: 'platformstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      dataSelected: [],

    }
  },
  computed: {
    ...mapState('MarketPlatform', ['platforms', 'isReceiving', 'isDeleting', 'idToDelete', 'marketplatformsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('MarketPlatform', ["getMarketPlatformsRequest", "getMarketPlatformQueryRequest", "deleteMarketPlatformRequest","updateMarketPlatformRequest","createMarketPlatformRequest"]),
    getJson(){
      let json = this.platforms.map(order=>{return {
        ordernum: order.platformnum, 
        orderdate: order.marketplatformdate!=undefined ? new Date(order.marketplatformdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.marketplatformdate!=undefined ? new Date(order.marketplatformdate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.platformtype,
        name: order.platformname, 
        address: order.marketplatformaddress,
        region: order.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == order.regionid)['regionname'] : '',
        township: order.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == order.townshipid)['townshipname'] : '',
        customertype: order.customertype,
        salesrep: order.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        paymentmethod: order.paymethodid!=undefined && this.paymethods.length>0 ? this.paymethods.find(method=>method._id == order.paymethodid)['paymethodname'] : '',
        tax: order.marketplatformtaxamount,
        subtotal: order.marketplatformsubtotal,
        total: order.marketplatformtotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.platformstatus=='Completed')!=null) return false;
      return true;
    },
    checkMarketPlatforms(){
      return this.dataSelected.filter(item=>item.platformstatus=='Completed').map(item=>item.platformnum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    editItem(item) {
      this.$router.push({ name: 'MarketPlatformEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'MarketPlatformPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'MarketPlatformView', params: item });
    },
    async findMarketPlatforms(){
      this.findMarketPlatformDialog = false;
      if(this.query=={}){
        await this.getMarketPlatformsRequest();
        this.platforms = Object.assign([], this.marketplatforms);
        this.platforms.push({marketplatformtotal: this.marketplatforms.reduce(function (last, json) {return last + json.marketplatformtotal;}, 0) });
      }
      else{
        let result = await this.getMarketPlatformQueryRequest(this.query);
        this.platforms = Object.assign([], result);
        this.platforms.push({marketplatformtotal: result.reduce(function (last, json) {return last + json.marketplatformtotal;}, 0) });
      }
    },
    async resetMarketPlatforms(){
      this.query = {};

    },
    async deleteItem(item) {
      await this.deleteMarketPlatformRequest({_id: item._id});
      this.platforms = this.marketplatforms;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.delete_platform = {
        _id: item._id,
        platformnum: item.platformnum,
        platformname: item.platformname,
      }
    },
  },
  async created () {
    if(this.$route.params.isDeposit==true) this.dataSelected = this.$route.params.orders;
    if(this.platforms.length==0) await this.getMarketPlatformsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
